import { CompositeLayer } from '@deck.gl/core';
import { IconLayer } from '@deck.gl/layers';

export const W3W_ICON_LAYER = 'w3w-icon-layer';

class W3WLayer extends CompositeLayer {
  initializeState() {
    super.initializeState();
  }

  onHover(info, pickingEvent) {
    // This bugfix suppressed the first hover after a click which causes
    // features like popovers to close immediately after a click.
    if (this.state.isClicked) {
      this.state.isClicked = false;
      return;
    }
    super.onHover(info, pickingEvent);
  }

  renderLayers() {
    const { data, w3wIconLayerProps, onHover } = this.props;
    const w3wIconLayer = new IconLayer(
      this.getSubLayerProps({
        id: W3W_ICON_LAYER,
        data: data,
        parameters: {
          depthTest: false,
        },
        onHover,
        ...w3wIconLayerProps,
      }),
    );

    return [w3wIconLayer];
  }
}

W3WLayer.layerName = 'W3WLayer';
W3WLayer.defaultProps = { visible: true, data: [] };

export default W3WLayer;
